<template>
    <div>
        <h3 class="text-center">เพิ่มวัตถุดิบ</h3>
        <div class="row form-group" v-if="form">
            <div class="col-4 text-right">ประเภทวัตถุดิบ</div>
            <div class="col-6">
                <input type="text" class="form-control" v-model="form.name"/>
            </div>
        </div>
        <div class="col text-center">
            <button type="button" @click="submitData"
                    class="btn btn-success">
                <icon name="save" style="width: 25px"></icon> บันทึก</button>&nbsp;&nbsp;
            <button type="button" @click="cancelData"
                    class="btn btn-outline-secondary">
                <icon name="times" style="width: 25px"></icon> ยกเลิก
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        props : {form : null},
        name: "MaterialTypeModal",
        methods:{
          submitData(){
              this.$emit("submit",this.form);
          },
          cancelData(){
              this.$emit("submit",false);
          }
        },
    }
</script>

<style scoped>

</style>
